var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.renderLoader)?_c('Tabs',{attrs:{"tabs":_vm.tabs,"activeTabOnMount":_vm.activeTab},on:{"updateTab":_vm.updateTab},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var tab = ref.tab;
var isActive = ref.isActive;
var updateTab = ref.updateTab;
return [_c('Observer',{on:{"on-change":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
return _vm.viewHandler.apply(void 0, [ tab ].concat( argsArray ))}}},[_c('TabItem',{key:tab.id,attrs:{"tab":tab,"isActive":isActive},on:{"click":function($event){return updateTab(tab.id)}}})],1)]}}],null,false,410235823)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }